import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faComments,
  faMagnifyingGlassChart,
  faSitemap,
  faPenRuler,
  faRocket,
  faArrowsSpin,
} from "@fortawesome/free-solid-svg-icons";
import "./Process.css";

const steps = [
  {
    step: "01",
    title: "Discovery & Vision Alignment",
    desc: "We begin with a deep dive into your business model, core margins, target audience, and goals to guarantee complete strategic alignment.",
    icon: faComments,
  },
  {
    step: "02",
    title: "In-Depth Audit & Opportunity Matrix",
    desc: "We inspect your technical baseline, search landscape, competitor moats, and conversion funnels to isolate your highest-ROI growth opportunities.",
    icon: faMagnifyingGlassChart,
  },
  {
    step: "03",
    title: "Roadmap & Architecture Blueprint",
    desc: "We lock in information architecture, campaign funnels, and wireframes early—giving you transparent milestones and guaranteed execution velocity.",
    icon: faSitemap,
  },
  {
    step: "04",
    title: "Conversion-Focused Build",
    desc: "High-performance coding, bespoke UI animations, compelling copywriting, and technical SEO compliance engineered under strict quality assurance.",
    icon: faPenRuler,
  },
  {
    step: "05",
    title: "Rigorous QA & High-Impact Launch",
    desc: "Multi-device audits, speed benchmarks, tracking pixel verification, and staging sign-off to ensure your go-live generates immediate trust.",
    icon: faRocket,
  },
  {
    step: "06",
    title: "Growth Optimization & Ongoing Scale",
    desc: "Post-launch, our team actively monitors conversion rates, runs campaign experiments, and supports your ongoing digital evolution.",
    icon: faArrowsSpin,
  },
];

const Process = () => {
  return (
    <section className="about-process" aria-label="Our working process">
      <div className="about-process-wrap">
        <motion.header
          className="about-process-head"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="about-process-kicker">Transparent Methodology</span>
          <h2>How We Build &amp; Scale Every Project</h2>
          <p>
            No black boxes. A battle-tested 6-stage lifecycle designed for speed,
            flawless communication, and measurable growth.
          </p>
        </motion.header>

        <div className="about-process-grid">
          {steps.map((step, index) => (
            <motion.div
              className="about-process-card"
              key={step.step}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              whileHover={{ y: -5, transition: { duration: 0.2 } }}
            >
              <div className="process-card-header">
                <div className="process-icon-box">
                  <FontAwesomeIcon icon={step.icon} />
                </div>
                <span className="process-step-badge">{step.step}</span>
              </div>

              <div className="about-process-content">
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>

              <div className="process-card-accent" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
